"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateRelatedEntityStatusPlugin = exports.UpdateRelatedEntityStatusErrorPlugin = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const entity_core_1 = require("@sierralabs/entity-core");
const entity_ui_1 = require("@sierralabs/entity-ui");
const workflow_core_1 = require("@sierralabs/workflow-core");
const useWorkflowItem_1 = require("../../hooks/useWorkflowItem");
const useFindTaskTypes_1 = require("../../task-types/hooks/useFindTaskTypes");
const useFindTaskTypeById_1 = require("../../task-types/hooks/useFindTaskTypeById");
const TaskTypePicker_1 = __importDefault(require("../../task-types/pickers/TaskTypePicker"));
const TaskStatusLabel_1 = __importDefault(require("../../tasks/components/TaskStatusLabel"));
const useTaskRedirect_1 = require("../../tasks/hooks/useTaskRedirect");
function validateRelation(value) {
    return !!(value.taskTypeId &&
        Array.isArray(value.propertyNames) &&
        value.propertyNames.length > 0 &&
        value.propertyNames.every(propertyName => !!propertyName) &&
        Array.isArray(value.events) &&
        value.events.length > 0);
}
const UpdateRelatedEntityStatusConfigurator = props => {
    var _a;
    const { taskTypeId, onChange } = props;
    const [open, setOpen] = (0, react_1.useState)(false);
    const [invoke, setInvoke] = (0, react_1.useState)(props.invoke);
    const [updateIndex, setUpdateIndex] = (0, react_1.useState)(-1);
    const [removeIndex, setRemoveIndex] = (0, react_1.useState)(-1);
    const { entities } = (0, entity_ui_1.useEntityContext)();
    if (!invoke.data)
        invoke.data = {};
    const data = invoke.data;
    const relations = data.relations || [];
    const { data: taskType, get } = (0, useFindTaskTypeById_1.useFindTaskTypeById)(taskTypeId || 0);
    // entity schema of current Workflow
    const schema = taskType
        ? entities === null || entities === void 0 ? void 0 : entities.find(schema => {
            return taskType.entityId
                ? schema.id === taskType.entityId
                : schema.tableName === taskType.entityTable;
        })
        : undefined;
    const update = (data) => {
        const updatedInvoke = Object.assign(Object.assign({}, invoke), { data });
        setInvoke(updatedInvoke);
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedInvoke);
    };
    const getPropertyDisplay = (relation) => {
        if (!relation) {
            return '?';
        }
        const properties = (0, entity_core_1.getEntityProperties)(relation.propertyNames, schema, entities || []);
        const property = properties
            .map(property => {
            var _a;
            return ((_a = property.relation) === null || _a === void 0 ? void 0 : _a.displayName) || property.propertyName || '?';
        })
            .join(' -> ');
        const entity = (schema === null || schema === void 0 ? void 0 : schema.displayName) || '?';
        return `${entity} -> ${property}`;
    };
    (0, react_1.useEffect)(() => {
        get();
    }, [get]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.TableContainer, null,
            react_1.default.createElement(core_1.Table, null,
                react_1.default.createElement(core_1.TableHead, null,
                    react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, null, "Name"),
                        react_1.default.createElement(core_1.TableCell, null, "Related Entity"),
                        react_1.default.createElement(core_1.TableCell, null, "Transitions"),
                        react_1.default.createElement(core_1.TableCell, { style: { width: 0 } }))),
                react_1.default.createElement(core_1.TableBody, null,
                    relations.length === 0 && (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: 4 }, "No relations added."))),
                    relations.map((relation, index) => (react_1.default.createElement(core_1.TableRow, { key: index, className: 'dense' },
                        react_1.default.createElement(core_ui_1.WrappedTableCell, null, relation.name || (react_1.default.createElement(core_1.Typography, { variant: 'body2', color: 'textSecondary' }, "Untitled"))),
                        react_1.default.createElement(core_ui_1.WrappedTableCell, null, getPropertyDisplay(relation)),
                        react_1.default.createElement(core_ui_1.WrappedTableCell, null, relation.events
                            .map(event => {
                            const target = (0, workflow_core_1.parseTaskStatus)(event.target);
                            return `${event.state} -> ${target}`;
                        })
                            .join(', ')),
                        react_1.default.createElement(core_1.TableCell, { padding: 'checkbox' },
                            react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: () => setUpdateIndex(index) },
                                react_1.default.createElement(icons_1.Edit, null)),
                            react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: () => setRemoveIndex(index) },
                                react_1.default.createElement(icons_1.Close, null))))))))),
        react_1.default.createElement(core_1.Box, { mt: 2 },
            react_1.default.createElement(core_1.Button, { variant: 'outlined', startIcon: react_1.default.createElement(icons_1.Add, null), onClick: () => setOpen(true) }, "Add Relation")),
        !schema && (react_1.default.createElement(core_1.Box, { mt: 2 },
            react_1.default.createElement(lab_1.Alert, { severity: 'error' }, "No schema found for this Workflow."))),
        schema && (react_1.default.createElement(AddRelationDialog, { schema: schema, open: open || updateIndex > -1, relation: relations[updateIndex], title: updateIndex > -1 ? 'Update Relation' : 'Add Relation', onCancel: () => {
                setOpen(false);
                setUpdateIndex(-1);
            }, onSubmit: relation => {
                data.entity = { id: schema.id, table: schema.tableName };
                if (!data.relations) {
                    data.relations = [];
                }
                if (updateIndex > -1) {
                    data.relations.splice(updateIndex, 1, relation);
                }
                else {
                    data.relations.push(relation);
                }
                setOpen(false);
                setUpdateIndex(-1);
                update(Object.assign({}, data));
            } })),
        react_1.default.createElement(core_ui_1.ConfirmDialog, { confirmLabel: 'Remove', open: removeIndex > -1, title: 'Remove Relation', message: `Are you sure you want to remove ${((_a = relations[removeIndex]) === null || _a === void 0 ? void 0 : _a.name) || 'this'} relation?`, onCancel: () => setRemoveIndex(-1), onConfirm: () => {
                if (!data.relations) {
                    data.relations = [];
                }
                if (removeIndex > -1) {
                    data.relations.splice(removeIndex, 1);
                }
                setRemoveIndex(-1);
                update(Object.assign({}, data));
            } })));
};
const StyledBox = (0, styled_components_1.default)(core_1.Box) `
  .grid-field {
    flex: 1;
  }
  .grid-action {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
  }
`;
const AddRelationDialog = props => {
    const { open, title, schema, relation: relationProp, onCancel, onSubmit } = props;
    const [relation, setRelation] = (0, react_1.useState)(() => relationProp || {});
    const { entities } = (0, entity_ui_1.useEntityContext)();
    const { data, isLoading: isFinding, findTaskTypes } = (0, useFindTaskTypes_1.useFindTaskTypes)();
    const { workflow } = (0, useWorkflowItem_1.useWorkflowItem)((0, react_1.useMemo)(() => ({ taskTypeId: relation.taskTypeId }), [relation.taskTypeId])) || {};
    const taskTypes = (0, react_1.useMemo)(() => data || [], [data]);
    const events = (0, react_1.useMemo)(() => {
        const allEvents = [];
        for (const state of (workflow === null || workflow === void 0 ? void 0 : workflow.stateNode.states) || []) {
            for (const event of state.events || []) {
                for (const transition of event.transitions || []) {
                    allEvents.push({
                        event: event.name || '',
                        state: state.name,
                        target: transition.target
                    });
                }
            }
        }
        return allEvents;
    }, [workflow]);
    const selectedEvents = (0, react_1.useMemo)(() => {
        const relationEvents = relation.events || [];
        return events.filter(event => {
            return relationEvents.some(relationEvent => {
                return (relationEvent.state === event.state &&
                    relationEvent.event === event.event &&
                    relationEvent.target === event.target);
            });
        });
    }, [events, relation]);
    const properties = (0, react_1.useMemo)(() => {
        return (0, entity_core_1.getEntityProperties)(relation.propertyNames, schema, entities || []);
    }, [relation, schema, entities]);
    // get last property.relation
    const propertyRelation = (0, react_1.useMemo)(() => {
        var _a;
        return (_a = properties[properties.length - 1]) === null || _a === void 0 ? void 0 : _a.relationSchema;
    }, [properties]);
    const entityId = propertyRelation === null || propertyRelation === void 0 ? void 0 : propertyRelation.id;
    const entityTable = propertyRelation === null || propertyRelation === void 0 ? void 0 : propertyRelation.tableName;
    const validRelation = validateRelation(relation) ? relation : undefined;
    (0, react_1.useEffect)(() => {
        if (entityId || entityTable) {
            findTaskTypes({ entityId, entityTable });
        }
    }, [entityId, entityTable, findTaskTypes]);
    // clear state
    (0, react_1.useEffect)(() => {
        if (!open) {
            setRelation({});
        }
    }, [open]);
    (0, react_1.useEffect)(() => {
        relationProp && setRelation(relationProp);
    }, [relationProp]);
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, open: open, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null, title),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_1.Box, null,
                react_1.default.createElement(core_1.TextField, { fullWidth: true, variant: 'outlined', label: 'Display Name', placeholder: 'Enter the display name of the Relation', value: relation.name || '', onChange: event => {
                        setRelation(relation => {
                            return Object.assign(Object.assign({}, relation), { name: event.target.value });
                        });
                    } })),
            react_1.default.createElement(core_1.Box, { mt: 2 },
                react_1.default.createElement(entity_ui_1.EntitySchemaPicker, { disabled: true, value: schema.name, textFieldProps: { label: 'Workflow Entity' } })),
            properties.map((property, index) => {
                var _a;
                return (react_1.default.createElement(StyledBox, { mt: 2, key: `${property.propertyName}-${index}` },
                    react_1.default.createElement(core_1.Grid, { container: true, spacing: 0 },
                        react_1.default.createElement(core_1.Grid, { item: true, className: 'grid-field' },
                            react_1.default.createElement(entity_ui_1.EntitySchemaRelationPicker, { schema: property.schema, value: property.propertyName, textFieldProps: {
                                    label: index === 0 ? 'Related Entity' : 'Entity Relation',
                                    placeholder: `Select a Relationship from ${((_a = property.schema) === null || _a === void 0 ? void 0 : _a.displayName) || '?'}`
                                }, onChange: relation => {
                                    const propertyName = relation === null || relation === void 0 ? void 0 : relation.propertyName;
                                    setRelation(relation => {
                                        relation = Object.assign({}, relation);
                                        if (!relation.propertyNames) {
                                            relation.propertyNames = [];
                                        }
                                        relation.propertyNames[index] = propertyName || '';
                                        if (!propertyName) {
                                            relation.events = [];
                                            relation.taskTypeId = undefined;
                                            // unset all subsequent relations
                                            relation.propertyNames.splice(index + 1);
                                        }
                                        return relation;
                                    });
                                } })),
                        index > 0 && (react_1.default.createElement(core_1.Grid, { item: true, className: 'grid-action' },
                            react_1.default.createElement(core_1.IconButton, { onClick: () => {
                                    setRelation(relation => {
                                        var _a;
                                        relation = Object.assign(Object.assign({}, relation), { events: [], taskTypeId: undefined });
                                        (_a = relation.propertyNames) === null || _a === void 0 ? void 0 : _a.splice(index);
                                        return relation;
                                    });
                                } },
                                react_1.default.createElement(icons_1.Close, null)))))));
            }),
            react_1.default.createElement(core_1.Box, { mt: 2 },
                react_1.default.createElement(core_1.Button, { fullWidth: true, variant: 'outlined', startIcon: react_1.default.createElement(icons_1.Add, null), 
                    // disabled if no selected for last property
                    disabled: !properties[properties.length - 1].propertyName, onClick: () => {
                        setRelation(relation => {
                            relation = Object.assign(Object.assign({}, relation), { events: [], taskTypeId: undefined });
                            if (!relation.propertyNames) {
                                relation.propertyNames = [];
                            }
                            relation.propertyNames.push('');
                            return relation;
                        });
                    } }, "Add Relation")),
            react_1.default.createElement(core_1.Box, { mt: 2 },
                react_1.default.createElement(TaskTypePicker_1.default, { options: taskTypes, isLoading: isFinding, value: relation.taskTypeId, disabled: !propertyRelation, textFieldProps: {
                        label: 'Entity Task Type',
                        placeholder: 'Select the Task Type of Entity'
                    }, onChange: taskType => {
                        // add display name if not set
                        const taskTypeLabel = taskType
                            ? `${taskType.label} (${taskType.prefix})`
                            : '';
                        setRelation(relation => {
                            relation = Object.assign(Object.assign({}, relation), { taskTypeId: taskType === null || taskType === void 0 ? void 0 : taskType.id, name: relation.name || taskTypeLabel });
                            if (!relation.taskTypeId) {
                                relation.events = [];
                            }
                            return relation;
                        });
                    } })),
            react_1.default.createElement(core_1.Box, { mt: 2 },
                react_1.default.createElement(lab_1.Autocomplete, { multiple: true, options: events, value: selectedEvents, disabled: !workflow || !relation.taskTypeId, getOptionLabel: option => {
                        const { event, state, target } = option;
                        return `${event} (${state} -> ${(0, workflow_core_1.parseTaskStatus)(target)})`;
                    }, onChange: (_, events) => {
                        setRelation(relation => (Object.assign(Object.assign({}, relation), { events })));
                    }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { variant: 'outlined', label: 'Event Transitions', placeholder: 'Select Event Transitions' }))) })),
            workflow && (react_1.default.createElement(core_1.Box, { mt: 2 },
                react_1.default.createElement(lab_1.Alert, { severity: 'info' },
                    "The ",
                    react_1.default.createElement("strong", null, "event transitions"),
                    " will trigger for the related entities. The related entities must be in a status that can transition to the target status.")))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { onClick: onCancel }, "Cancel"),
            react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', disabled: !validRelation, onClick: () => {
                    if (validRelation) {
                        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(validRelation);
                    }
                } }, "Save"))));
};
const StyledDisplayDiv = styled_components_1.default.div `
  font-size: 13px;
  padding-left: 4px;
  text-indent: -4px;
`;
const UpdateRelatedEntityStatusDisplay = props => {
    const { invoke } = props;
    if (!invoke.data)
        invoke.data = {};
    const data = invoke.data;
    const relations = data.relations || [];
    return (react_1.default.createElement(StyledDisplayDiv, null, relations.map((relation, index) => {
        const name = relation.name || 'Untitled';
        const { length } = relation.events;
        return (react_1.default.createElement("div", { key: `${name}-${index}` },
            name,
            ": ",
            length,
            " transition",
            length !== 1 && 's'));
    })));
};
const StyledDialogContent = (0, styled_components_1.default)(core_1.DialogContent) `
  .group-title {
    padding-bottom: 0;
    margin-top: 8px;
  }
  .item {
    padding-bottom: 0;
  }
  .content {
    flex: 1;
    .title {
      margin-bottom: 1px;
      .flex {
        display: inline-flex;
        align-items: center;
        .MuiTypography-root {
          font-weight: bold;
        }
      }
    }
    .status-label {
      padding: 3px 7px;
      margin-left: 6px;
      margin-right: 6px;
    }
    .subtitle {
      margin-bottom: 2px;
    }
  }
  .icon {
    margin-top: 2px;
  }
  .error {
    color: ${props => props.theme.palette.error.main};
  }
`;
const ErrorPluginView = props => {
    const { error, onCancel } = props;
    const { items } = error.metadata.data;
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const { getRedirectUrl } = (0, useTaskRedirect_1.useTaskRedirect)();
    // group items by relationName
    const groups = (0, react_1.useMemo)(() => {
        const groups = [];
        for (const item of items) {
            const { relationName } = item;
            const index = groups.findIndex(group => group.relationName === relationName);
            const group = groups[index] || { items: [], relationName };
            if (index < 0) {
                groups.push(group);
            }
            group.items.push(item);
        }
        return groups;
    }, [items]);
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, open: true, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null, "Transition Error"),
        react_1.default.createElement(StyledDialogContent, null,
            react_1.default.createElement(core_1.Box, { mb: 2 },
                react_1.default.createElement(core_1.Typography, null, error.message),
                react_1.default.createElement(core_1.Typography, { variant: 'body2', color: 'textSecondary' },
                    "Source: ",
                    react_1.default.createElement("strong", null, exports.UpdateRelatedEntityStatusPlugin.name),
                    ' ',
                    "Plugin")),
            items.length > 0 && (react_1.default.createElement(core_1.Box, { mb: 1 },
                react_1.default.createElement(lab_1.Alert, { severity: 'warning' },
                    react_1.default.createElement(lab_1.AlertTitle, null,
                        "Total Issues: ",
                        items.length),
                    "There are issues found while transitioning this item. You can go through each ",
                    react_1.default.createElement("strong", null, "Related Entity"),
                    " below in order to resolve the issue and try again."))),
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
                items.length === 0 && (react_1.default.createElement(core_1.Grid, { item: true, xs: 12 }, "No items to display.")),
                groups.map((group, groupIndex) => (react_1.default.createElement(react_1.Fragment, { key: `${group.relationName}-${groupIndex}` },
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, className: 'group-title' },
                        react_1.default.createElement(core_1.Typography, { variant: 'body2', color: 'textSecondary' }, group.relationName)),
                    group.items.map((item, itemIndex) => (react_1.default.createElement(ErrorItem, { item: item, isLoading: isLoading, key: `${item.task.id}-${itemIndex}`, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                            setIsLoading(true);
                            const url = yield getRedirectUrl(item.task);
                            setIsLoading(false);
                            url && window.open(url, '_blank');
                        }) })))))))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { onClick: onCancel }, "Close"))));
};
const ErrorItem = props => {
    const { item, isLoading, onClick } = props;
    const { task, event } = item;
    return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, className: 'item' },
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(icons_1.HighlightOff, { className: 'icon error' })),
            react_1.default.createElement(core_1.Grid, { item: true, className: 'content' },
                react_1.default.createElement("div", { className: 'title' },
                    react_1.default.createElement(core_1.Box, { className: 'flex' },
                        react_1.default.createElement(core_1.Typography, { variant: 'subtitle1' }, task.key),
                        react_1.default.createElement(TaskStatusLabel_1.default, { task: task }),
                        react_1.default.createElement(core_1.Tooltip, { arrow: true, placement: 'right', title: 'Open in New Tab' },
                            react_1.default.createElement(core_1.IconButton, { size: 'small', color: 'primary', disabled: isLoading, onClick: onClick },
                                react_1.default.createElement(icons_1.OpenInNew, { fontSize: 'small' }))))),
                react_1.default.createElement(core_1.Typography, { variant: 'subtitle2' }, task.name),
                react_1.default.createElement(core_1.Typography, { variant: 'body2', color: 'textSecondary', className: 'subtitle' },
                    event.event,
                    " (",
                    event.state,
                    ' -> ',
                    (0, workflow_core_1.parseTaskStatus)(event.target),
                    ")"),
                react_1.default.createElement(core_1.Typography, { color: !item.message ? 'textSecondary' : undefined }, item.message || 'No error message.')))));
};
exports.UpdateRelatedEntityStatusErrorPlugin = {
    type: 'updateRelatedEntityStatus',
    render: ErrorPluginView
};
exports.UpdateRelatedEntityStatusPlugin = {
    src: 'updateRelatedEntityStatus',
    name: 'Update Related Entity Status',
    configurator: UpdateRelatedEntityStatusConfigurator,
    display: UpdateRelatedEntityStatusDisplay,
    error: exports.UpdateRelatedEntityStatusErrorPlugin,
    validate: (condition) => {
        const data = condition.data;
        return !!(data &&
            data.entity &&
            (data.entity.id || data.entity.table) &&
            Array.isArray(data.relations) &&
            data.relations.length > 0 &&
            data.relations.every(relation => {
                return (relation.taskTypeId &&
                    Array.isArray(relation.events) &&
                    relation.events.length > 0 &&
                    relation.events.every(event => event.event && event.state && event.target) &&
                    Array.isArray(relation.propertyNames) &&
                    relation.propertyNames.length > 0 &&
                    relation.propertyNames.every(name => !!name));
            }));
    },
    service: (state, params) => {
        console.log('updateRelatedEntityStatus params', state, params);
        return true;
    }
};
//# sourceMappingURL=UpdateRelatedEntityStatusPlugin.js.map